import React from "react";

const Loading = () => {
    return (
        <>
            <div style={{ width: "1200px", height: "800px" }}>
                <div >
                    <h1
                        style={{
                            fontSize: "50px",
                            marginTop: "200px",
                            marginLeft: "500px",
                        }}
                    >
                        Loading......
                    </h1>
                </div>
            </div>
        </>
    );
};

export default Loading;